import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@mantine/core";
import { Page } from "../../layout/page";
import ConsultantCpdSubmitWizard from "../../components/consultantCpdSubmitWizard";

const SubmitCpdCertificate = () => {
  const navigate = useNavigate();

  return (
    <Page
      title="Submit Certificate"
      actions={
        <Button variant="default" onClick={() => navigate("/consultant/myCPD")}>
          Back to My CPD & CPT
        </Button>
      }
    >
      <ConsultantCpdSubmitWizard
        onSubmitted={() =>
          navigate("/consultant/myCPD", { state: { cpdSubmitted: true } })
        }
        onCancel={() => navigate("/consultant/myCPD")}
      />
    </Page>
  );
};

export default SubmitCpdCertificate;
